/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { type Request } from '../../interface/Crash';
import { JsiInterceptorFrameDetailsView } from './JsiInterceptorFrameDetailsView';
import { formatTimeHHmmssSSS } from '../../helper/formatTime';

export const RequestJsiView: React.FC<{
    request: Request;
}> = ({ request }) => {
    const frames = request.response?.frames;

    const processedFrames = useMemo(() => {
        if (!frames) return [];
        return Object.entries(frames)
            .filter(([id]) => id !== '__class__' && id !== '__id__')
            .map(([id, frame]) => ({
                id,
                frame,
                formattedTime: formatTimeHHmmssSSS(frame.time),
                requestCount: Object.keys(frame.requests ?? []).filter(
                    (k) => k !== '__class__' && k !== '__id__',
                ).length,
            }));
    }, [frames]);

    if (!frames) return <></>;

    return (
        <div>
            <Accordion allowToggle>
                {processedFrames.map(({ id, frame, formattedTime, requestCount }) => (
                    <AccordionItem key={id}>
                        <h2>
                            <AccordionButton fontWeight="semibold">
                                <Box as="span" flex="1" textAlign="left">
                                    {frame.url}
                                </Box>
                                <Box as="span" flex="1" textAlign="right" maxWidth="200">
                                    {formattedTime}
                                </Box>
                                <Box as="span" flex="1" textAlign="right" maxWidth="50">
                                    {requestCount}
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                            <JsiInterceptorFrameDetailsView frame={frame} />
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
};
